"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxGroup = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var stitches_config_1 = require("../stitches.config");
var Checkbox_1 = require("./Checkbox");
var CheckboxContainer = (0, stitches_config_1.styled)("div", {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
});
function CheckboxGroup(props) {
    return ((0, jsx_runtime_1.jsx)(CheckboxContainer, { children: props.options.map(function (option) {
            return ((0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, { disabled: props.disabled, label: option.label, checked: props.value && props.value.indexOf(option.value) !== -1, onCheckedChange: function (checked) {
                    if (checked) {
                        props.onChange && props.onChange(__spreadArray(__spreadArray([], props.value, true), [option.value], false));
                    }
                    else {
                        var selectedOptionsCopy = __spreadArray([], props.value, true);
                        var index = selectedOptionsCopy.indexOf(option.value);
                        if (index !== -1) {
                            selectedOptionsCopy.splice(index, 1);
                        }
                        props.onChange && props.onChange(selectedOptionsCopy);
                    }
                } }));
        }) }));
}
exports.CheckboxGroup = CheckboxGroup;
//# sourceMappingURL=CheckboxGroup.js.map